import { useTranslation } from 'react-i18next'
import React from 'react'

import { RefetchingIndicator } from '../../../../components/helpers/StatePresenter'
import { useGetColor } from '../../../../packages/kiti/components/theme/_hooks/colors'
import { useOpenEditTagModal } from '../../../../utils/routes/modals/modalsActions'
import { useRowActionsColumn } from '../../../../components/tables/Table'
import { useTagsActionsList } from '../../../../utils/actions/tags/list'
import { useTagsState } from '../_load/TagsLoader'
import Circle from '../../../../packages/kiti/components/shapes/Circle'
import DataTable from '../../../../packages/kiti/components/table/DataTable'
import Link from '../../../../packages/kiti/components/actions/Link'
import Text from '../../../../packages/kiti/components/presentation/Text'

const TagsTable = props => {
  const { t } = useTranslation('tags')
  const { tags: data } = useTagsState()
  const getColor = useGetColor()
  const onEdit = useOpenEditTagModal()

  const columns = [
    {
      label: t('color'),
      dataIndex: 'color',
      width: 4,
      headerSideContent: <RefetchingIndicator />,
      render: color => <Circle color={getColor(color)} size={1.4} />
    },
    {
      label: t('name'),
      dataIndex: 'name',
      sortIndex: 'NAME',
      flex: 4,
      render: (name, record) => (
        <Link onClick={() => onEdit(record)}>
          <Text>{name}</Text>
        </Link>
      )
    },
    {
      label: t('actions', { ns: 'common' }),
      width: 5,
      render: useRowActionsColumn(useTagsActionsList)
    }
  ]

  return <DataTable rowKey="id" columns={columns} data={data} inPanel size="medium" {...props} />
}

export default TagsTable
